import { useRouter } from 'next/router';
import { useContext, useEffect } from 'react';
import { useCartAdd } from 'src/hooks/useCartAdd';
import { useModal } from 'src/hooks/useModal';
import type { Product } from 'src/models/product/schema';
import { I18nContext } from 'src/stores/I18n';
import type { LOCALE_TYPE } from 'src/types/locale';
import { convertLocaleForZendesk } from 'src/utils/convertLocaleForZendesk';
import { closeZendesk, openZendesk } from 'src/utils/zendesk';
import { Presenter } from './Presenter';

export const MedicalSuppliesConfirmModal: React.FC = () => {
  const { isVisible, setIsVisible, modalParams, setModalParams } = useModal('chemicalConfirmModal');
  const localeResources = useContext(I18nContext);
  const { onAddToCart } = useCartAdd({ targetAttributionToken: modalParams.extraData?.targetAttributionToken });
  const { pathname, locale } = useRouter();
  const productSaleInfoHref = `https://wamazing.zendesk.com/hc/${convertLocaleForZendesk(
    locale as LOCALE_TYPE
  )}/categories/360003010811`;
  const closeModal = () => {
    setModalParams({
      type: 'info'
    });
    closeZendesk();
    setIsVisible(false);
  };

  useEffect(() => {
    if (!isVisible) {
      closeZendesk();
    }
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <Presenter
      localeResources={localeResources}
      product={modalParams.product as Product}
      quantity={modalParams.quantity as number}
      isProductList={pathname.indexOf('products/[id]') < 0}
      productSaleInfoHref={productSaleInfoHref}
      closeModal={closeModal}
      closeZendesk={closeZendesk}
      openZendesk={openZendesk}
      onAddToCart={onAddToCart}
      setIsVisible={setIsVisible}
    />
  );
};
